import { call, delay, putResolve, select, takeEvery } from 'redux-saga/effects';

import { autoUpdateActiveStakes, TOGGLE_AUTO_UPDATE } from '../actions/activeStakes';
import { selectAutoUpdate } from '../selectors/activeStakes';

const AUTO_RELOAD_INTERVAL = 5000;
function* refreshStakes() {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  yield putResolve(autoUpdateActiveStakes());
}

export default function* activeStakesSaga() {
  yield takeEvery(TOGGLE_AUTO_UPDATE, function* () {
    while (true) {
      const autoUpdate: boolean = yield select(selectAutoUpdate);
      if (autoUpdate) {
        yield delay(AUTO_RELOAD_INTERVAL);
        yield call(refreshStakes);
      }
      else {
        break;
      }
    }
  });
}

